export default "__VITE_ASSET__BzwuDGnK__"